import { useRouter } from 'next/router'

import Spinner from '~/components/Spinner'
import FactorizationActivities from '~/bootcamp/Activities/Factorization/FactorizationActivities'
import FractionActivities from '~/bootcamp/Activities/Fractions/FractionActivities'
import MultiplicationActivities from '~/bootcamp/Activities/Multiplication/MultiplicationActivities'
import PemdasActivities from '~/bootcamp/Activities/PEMDAS/PemdasActivities'
import PlanarFiguresActivities from '~/bootcamp/Activities/Geometry/PlanarFigures/PlanarFiguresActivities'
import StatisticsActivities from '~/bootcamp/Activities/Statistics/StatisticsActivities'

import { ActivityGroupProps, activityTypes } from './types/activities.types'
import AlgebraActivities from './Algebra/AlgebraActivities'

function Activities(activityData: ActivityGroupProps): React.ReactElement {
  const router = useRouter()
  const key = activityData.keyFromIntro ?? router.query.key
  switch (key) {
    case activityTypes.multiplication:
      return <MultiplicationActivities {...activityData} />
    case activityTypes.pemdas:
      return <PemdasActivities {...activityData} />
    case activityTypes.factorization:
      return <FactorizationActivities {...activityData} />
    case activityTypes.fraction:
      return <FractionActivities {...activityData} />
    case activityTypes.planarFigures:
      return <PlanarFiguresActivities {...activityData} />
    case activityTypes.algebraicExpressions:
      return <AlgebraActivities {...activityData} />
    case activityTypes.statistics:
      return <StatisticsActivities {...activityData} />
    default:
      return (
        <div className="w-full flex justify-center">
          <Spinner color="purple" size={50} />
        </div>
      )
  }
}

export default Activities
